import { Injectable, inject } from "@angular/core";

import { Utilities } from "@tylertech/shared-module";
import { ApiService } from "@tylertech/core-module";
import { InputParameterService } from "@tylertech/search-module";
import
{
    BankCodeLookupViewModel,
    ExecutionResult,
    IBankCodeLookupService,
    LookupCriteria,
} from "@tylertech/tyler-api-types";

/**
 * TODO - Split this up into API service and front-end service to support ExpressService attribute in Tyler.Api
 */
@Injectable()
export class BankCodeService implements IBankCodeLookupService
{
    private readonly $apiService = inject(ApiService);
    private readonly $inputParameterService = inject(InputParameterService);


    Lookup(criteria: LookupCriteria): Promise<ExecutionResult<BankCodeLookupViewModel[]>>
    {
        return this.$apiService.sendAuth("IBankCodeLookupService/Lookup", criteria);
    }

    lookup(value?: string): Promise<BankCodeLookupViewModel[]>
    {
        const criteria: LookupCriteria = {
            Parameters: []
        };
        if (value)
        {
            if (Utilities.isGuid(value))
            {
                criteria.Parameters.push(
                    this.$inputParameterService.createTextParameter({
                        Label: "Id",
                        FieldId: "Id",
                        Value: value,
                    })
                );
            }
            else
            {
                criteria.SearchText = value;
            }
        }
        return this.Lookup(criteria)
            .then(x => x.Result);
    }
}
